import * as React from 'react'
import { useParams } from 'react-router-dom';
import { getProjectDetailedById } from '../../globals/ApiHooks';
import Project, { ProjectId } from '../../shared/Project';
import { ColumnFlexBox, RowFlexBox } from '../../components/templates/Wrappers'
import { createEnDaContent, lang, translateContent } from '../../globals/Translations';
import { TabletMax } from '../../globals/UIValues';
import FBContent from '../../components/templates/FBContent'
import { ErrorPage } from '../Error';
import { ContentType } from '../../shared/Globals';
import { ProjectMapPrintable } from '../../components/organisms/ProjectMapPrintable';
import colors from '../../globals/colors';


const printPage = () => {
  setTimeout(function () {
    window.print()
  }, 1200);
}

export const PrintableDetailedProject: React.FC = () => {
  let { id } = useParams<{ id: ProjectId }>();
  const [project, setProject] = React.useState<Project>()
  const [error, setError] = React.useState(false)


  React.useEffect(() => {
    (async () => {
      const project = await getProjectDetailedById(id)
      if (project && project.projectId) { setProject(project); printPage() }
      else setError(true)
    })()
  }, [])

  React.useEffect(() => {
    if (project) document.title = `${translateContent(project.projectTitle)} | ${lang('Fundbricks.com')}`
  }, [project])


  if (error) return <ErrorPage message={translateContent(createEnDaContent("Could't find project: " + id, "Kunne ikke finde projekt med id: " + id))} />

  const sharUrl = "https://fundbricks.com/projects/" + id

  return (
    <ColumnFlexBox>
      <ColumnFlexBox>
        <h3 className='noprint' style={{ textAlign: 'center' }}>LOADING..</h3>
      </ColumnFlexBox >
      <div className='print'>
        <div className="page-header" >
          <RowFlexBox style={{ flexDirection: 'row-reverse' }}>
            <img width="100px" height="22px" alt="Fundbricks logo"
              src="https://prod-attachments-bucket-fb-2-0.s3.eu-west-1.amazonaws.com/59c23268-89c9-4132-9a6c-c97a7aa61eff.png" />
          </RowFlexBox>
        </div>

        <div className="page-footer">
          <RowFlexBox style={{ justifyContent: 'center', marginTop: 12 }}>
            <p style={{ fontSize: 12, color: colors.grayText, textAlign: 'center', margin: 0, padding: 0 }}>Fundbricks.com · Strandvejen 100, 4 sal - 2900 Hellerup, Danmark · CVR nr.: 40431934</p>
          </RowFlexBox>
        </div>
        <table>
          <thead>
            <tr>
              <td>
                <div className="page-header-space"></div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <ColumnFlexBox style={{ maxWidth: TabletMax, marginLeft: 'auto', marginRight: 'auto' }}>
                  <ColumnFlexBox className='pagebreak'>
                    <h1>{project && translateContent(project.projectTitle)}</h1>
                    <h4>{translateContent(createEnDaContent("Investor information", "Investorinformation"))}</h4>
                    <p>{translateContent(createEnDaContent("Project link", "Projekt link"))}: <a href={sharUrl}>{sharUrl}</a></p>
                    <img src={project?.images[0]} alt="Project image" />
                  </ColumnFlexBox>
                  <ColumnFlexBox>
                    <h4>{translateContent(createEnDaContent("Project introduction", "Projekt introduktion"))}</h4>
                    <FBContent content={project ? translateContent(project.projectTeaser) : ''} contentType={ContentType.Markdown} />
                  </ColumnFlexBox>
                  <ColumnFlexBox>
                    {project?.localizedContent && <ProjectMapPrintable localizedContent={project.localizedContent} />}
                  </ColumnFlexBox>
                </ColumnFlexBox>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div className="page-footer-space"></div>
              </td>
            </tr>
          </tfoot>
        </table>

      </div>

    </ColumnFlexBox>
  )
};
